<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item,index) in shipmentsRecordTabs"
          :label="item.title"
          :name="item.name"
          class="tab-text"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <div class="item-box-content" style="padding-bottom:0">
        <el-form label-width="70px">
          <el-row :gutter="20">
            <el-col :span="6" v-show="activeName!=='1'">
              <el-form-item label="发货编号：">
                <el-input v-model="valList[0].value"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="合同编号：">
                <el-input v-model="valList[1].value"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="客户合同编号：" label-width="98px">
                <el-input v-model="valList[2].value"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="签订时间：" v-show="activeName==='1'">
                <el-date-picker
                  v-model="time"
                  type="daterange"
                  range-separator="至"
                  style="width:100%"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00','23:59:59']"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="客户名称：">
                <el-input v-model="valList[3].value" :disabled="false"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所在仓库：">
                <el-select v-model="valList[4].value">
                  <el-option
                    v-for="(m, i) in houseSelect"
                    :key="i"
                    :value="m.id"
                    :label="m.storageName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="货期：" label-width="42px">
                <el-input v-model="valList[5].value" style="width: calc(100% - 20px)"></el-input>&nbsp;天
              </el-form-item>
            </el-col>
            <el-col :span="6" v-show="activeName!=='1'">
              <el-form-item label="配送方式：">
                <el-select v-model="valList[6].value">
                  <el-option value="物流配送"></el-option>
                  <el-option value="快递配送"></el-option>
                  <el-option value="客户自提"></el-option>
                  <el-option value="仓库配送"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-show="activeName==='1'||showAll">
              <el-form-item label="品牌：" label-width="42px">
                <el-select filterable v-model.trim="valList[7].value">
                  <el-option v-for="(m, i) in brandList" :key="i" :value="m.value" :label="m.label"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-show="showAll">
              <el-form-item label="型号：" label-width="42px">
                <el-input v-model="valList[8].value"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-show="showAll">
              <el-form-item label="订货号：" label-width="56px">
                <el-input v-model="valList[9].value"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="!showAll?6:activeName==='1'?18:12" style="text-align: right">
              <el-button @click="onSearch" type="primary" style="margin-bottom:20px">搜索</el-button>
              <el-button @click="onReset">重置</el-button>
              <el-button v-show="activeName === '1' || activeName === '4'" @click="handleExport" :loading="exportLoading" style="margin-bottom:20px">导出</el-button>
              <el-button type="text" @click="showAll = !showAll">
                {{showAll?'收起':'展开'}}
                <i
                  :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"
                ></i>
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div
        class="box-table"
        :style="{height: activeName==='1'?'':showAll? $store.state.Sell.height-97+'px': $store.state.Sell.height-48+'px',paddingBottom:(total===0&&activeName==='1')?'30px':'20px'}"
      >
        <el-row style="margin-bottom:10px" v-show="activeName==='1'">
          <el-col :span="8" :offset="16" style="text-align: right">
            <el-button @click="onReleaseRepertoryT" type="primary">移入发货区</el-button>
          </el-col>
        </el-row>
        <el-table
          border
          ref="topTableRef"
          :data="list"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          :max-height="activeName==='1'?'378':showAll? $store.state.Sell.height-97:$store.state.Sell.height-48"
          element-loading-spinner="el-icon-loading"
          @row-click="onRowClickT"
          @selection-change="handleSelectionChangeT"
          @row-dblclick="RowDbclickT"
        >
          <template slot="empty" v-show="activeName==='1'">
            <no-data :nodata="`nodataPurchase`">暂无发货产品！</no-data>
          </template>
          <el-table-column type="selection" width="45" v-if="activeName==='1'" key="0" fixed></el-table-column>
          <el-table-column
            label="发货编号"
            width="150"
            show-overflow-tooltip
            fixed
            v-if="activeName!=='1'"
            key="1"
          >
            <template slot-scope="scope">
              <span class="approval" @click="toDetail(scope.row)">{{scope.row.deliverNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column label="合同编号" width="150" show-overflow-tooltip fixed key="2">
            <template slot-scope="scope">
              <span class="approval" @click="toHeTong(scope.row)">{{scope.row.contractCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户合同编号" show-overflow-tooltip width="125" key="3">
            <template slot-scope="scope">{{scope.row.customerContractCode||'--'}}</template>
          </el-table-column>
          <el-table-column label="签订时间" show-overflow-tooltip width="125" key="4">
            <template v-slot="{row}">{{row.signingTime|dateFilter}}</template>
          </el-table-column>
          <el-table-column label="客户名称" min-width="110" show-overflow-tooltip key="5">
            <template slot-scope="scope">
              <div
                class="approval line-limit-length"
                @click="toKeHu(scope.row)"
              >{{scope.row.customerName}}</div>
            </template>
          </el-table-column>
          <el-table-column label="品牌" show-overflow-tooltip prop="brandName" key="6"></el-table-column>
          <el-table-column label="型号" show-overflow-tooltip key="7">
            <template slot-scope="scope">
              <div
                class="approval line-limit-length"
                @click="onProductDetail(scope.row)"
              >{{ scope.row.proType }}</div>
            </template>
          </el-table-column>
          <el-table-column label="订货号" show-overflow-tooltip prop="orderNumber" key="8"></el-table-column>
          <el-table-column label="所在仓库" show-overflow-tooltip prop="storageName" key="9"></el-table-column>
          <el-table-column label="货期" key="10">
            <template slot-scope="scope">{{scope.row.ocExtime}}天</template>
          </el-table-column>
          <el-table-column label="数量" prop="count" key="11"></el-table-column>
          <el-table-column label="配送方式" v-if="activeName!=='1'" prop="deliverMode" key="12"></el-table-column>
          <el-table-column
            label="发货信息"
            prop="message"
            width="150"
            v-if="activeName!=='1'"
            show-overflow-tooltip
            key="13"
          ></el-table-column>
          <el-table-column label="请求发货时间" width="125" v-if="activeName!=='1'" key="14">
            <template slot-scope="scope">{{scope.row.createDate|dateFilter}}</template>
          </el-table-column>
          <el-table-column label="实际发货时间" width="125" v-if="activeName==='4'" key="15">
            <template slot-scope="scope">{{scope.row.soDate|dateFilter}}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination" v-show="!(total===0&&activeName==='1')">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
      <div class="box-table" style="margin-top:20px" v-show="activeName==='1'">
        <el-row>
          <el-col :span="12" class="title-font-style">
            <span>发货区</span>
          </el-col>
          <el-col :span="12" style="text-align: right;">
            <el-button @click="onReleaseRepertoryB">移出发货区</el-button>
          </el-col>
        </el-row>
        <el-table
          style="margin:10px 0 20px"
          border
          ref="botTableRef"
          :data="bottomList"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          max-height="378"
          @row-click="onRowClickB"
          @selection-change="handleSelectionChangeB"
          @row-dblclick="RowDbclickB"
        >
          <template slot="empty">
            <no-data :nodata="`nodataPurchase`">请选择发货产品！</no-data>
          </template>
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column label="合同编号" width="150" show-overflow-tooltip fixed>
            <template slot-scope="scope">
              <span class="approval" @click="toHeTong(scope.row)">{{scope.row.contractCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户合同编号" show-overflow-tooltip width="125">
            <template slot-scope="scope">{{scope.row.customerContractCode||'--'}}</template>
          </el-table-column>
          <el-table-column label="签订时间" show-overflow-tooltip width="125">
            <template v-slot="{row}">{{row.signingTime|dateFilter}}</template>
          </el-table-column>
          <el-table-column label="客户名称" min-width="110" show-overflow-tooltip>
            <template slot-scope="scope">
              <div
                class="approval line-limit-length"
                @click="toKeHu(scope.row)"
              >{{scope.row.customerName}}</div>
            </template>
          </el-table-column>
          <el-table-column label="品牌" show-overflow-tooltip prop="brandName"></el-table-column>
          <el-table-column label="型号" show-overflow-tooltip>
            <template slot-scope="scope">
              <div
                class="approval line-limit-length"
                @click="onProductDetail(scope.row)"
              >{{ scope.row.proType }}</div>
            </template>
          </el-table-column>
          <el-table-column label="订货号" show-overflow-tooltip prop="orderNumber"></el-table-column>
          <el-table-column label="所在仓库" show-overflow-tooltip prop="storageName"></el-table-column>
          <el-table-column label="货期" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.ocExtime}}天</template>
          </el-table-column>
          <el-table-column label="数量" fixed="right" width="160">
            <template slot-scope="scope">
              <el-input-number
                size="small"
                v-model="scope.row.count"
                controls-position="right"
                :min="1"
                :max="scope.row.max"
              ></el-input-number>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-button type="primary" :disabled="bottomList.length===0" @click="onShipments">发起发货</el-button>
          <div style="display: flex;padding-bottom:5px;">
            <i class="el-icon-warning-outline" style=" margin-top: 12px;"></i>
            <span class="warning-text">提示：只允许同一客户的产品同时发起发货</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { shipmentsRecordTabs } from './util/data'
import noData from '@/components/module/noData'
import { queryDeliverContent, unshippedExport, shippedExport } from '@/api/sell/sellManage'
import { houseInformation } from '@/api/storage/storage'
import pagination from '@/components/pagination'
import { downLoadFileBlob } from '@/util/tool'
export default {
  components: { pagination, noData },
  data() {
    return {
      params: {},
      valList: [
        { value: '', column: 'deliverNumber' },
        { value: '', column: 'contractCode' },
        { value: '', column: 'customerContractCode' },
        { value: '', column: 'customerName' },
        { value: '', column: 'storageName' },
        { value: '', column: 'ocExtime' },
        { value: '', column: 'deliverMode' },
        { value: '', column: 'brandName' },
        { value: '', column: 'proType' },
        { value: '', column: 'orderNumber' }
      ],
      time: [],
      showAll: false,
      houseSelect: [],
      brandList: [],
      activeName: '1',
      shipmentsRecordTabs,
      listID: [],
      list: [], // 列表数据
      bottomList: [], // 备货区列表
      tempTopList: [], // 选中 未发货
      tempBotList: [], // 选中 发货区
      loadingTable: false, // 列表loading
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      exportLoading: false
    }
  },
  watch: {
    time(newValue) {
      if (newValue === null) this.time = []
    },
    bottomList: {
      handler(newVal) {
        if (this.activeName === '1') {
          this.listID = []
          for (let i = 0; i < newVal.length; i++) {
            if (!newVal[i].count) {
              newVal.splice(i, 1)
              i--
              return
            }
            if (newVal[i].count === newVal[i].max) {
              this.listID.push(newVal[i].moveInAndOut)
            }
          }
          this.getList()
        }
      },
      deep: true
    }
  },
  mounted() {
    houseInformation().then((res) => {
      if (res.data.code === 200) {
        this.houseSelect = res.data.obj
      }
    })
    this.getBrandForSelect()
    this.getList()
  },
  methods: {
    onShipments() {
      this.$store.state.Sell.tempBotList = this.bottomList
      this.$router.push({
        name: 'sellShipments',
        query: { id: this.bottomList[0].customerId }
      })
    },
    onSearch() {
      // 搜索
      this.params = {}
      if (this.valList.some((ele) => ele.value) || this.time.length) {
        this.pageSize = 30
        this.currentPage = 1
        this.valList.forEach((ele) => {
          if (ele.value) {
            this.$set(this.params, ele.column, ele.value)
          }
        })
        if (this.time.length) {
          this.$set(this.params, 'signingTimeBegin', this.time[0])
          this.$set(this.params, 'signingTimeEnd', this.time[1])
        }
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    onReset() {
      this.showAll = false
      this.valList.forEach((ele) => {
        delete ele.value
      })
      this.params = {}
      this.time = []
      this.pageSize = 30
      this.currentPage = 1
      this.getList()
    },
    onProductDetail(row) {
      this.$router.push({ name: 'productDetails', query: { id: row.proId } })
    },
    toDetail(row) {
      this.$router.push({
        name: 'shipmentsEdit',
        query: { ocdId: row.deliverId }
      })
    },
    // 合同详情
    toHeTong(row) {
      this.$router.push({
        name: 'contractEdit',
        query: { id: row.contractId, cusId: row.customerId }
      })
    },
    // 客户详情
    toKeHu(row) {
      this.$router.push({
        path: '/crm/customer/details',
        query: { id: row.customerId }
      })
    },
    // 获取所有品牌名称
    async getBrandForSelect() {
      this.brandList = await this.$queryAllBrandForSelect()
    },
    // ---------------未发货
    topChange(row) {
      const index = this.list.findIndex((m) => m.moveInAndOut === row.moveInAndOut)
      this.list.splice(index, 1)
      if (this.bottomList.every((m) => m.moveInAndOut !== row.moveInAndOut)) {
        row.count = row.max
        this.bottomList.push(row)
      } else {
        this.bottomList.forEach((ele) => {
          if (ele.moveInAndOut === row.moveInAndOut) {
            ele.count = ele.max
          }
        })
      }
    },
    RowDbclickT(row) {
      if (this.activeName === '1') {
        if (this.bottomList.length === 0 || row.customerId === this.bottomList[0].customerId) {
          this.topChange(row)
        } else {
          this.$message.error('仅允许同一客户的产品移入发货区！')
        }
      }
    },
    onReleaseRepertoryT() {
      if (this.tempTopList.length === 0) {
        this.$message.error('请选中产品！')
      } else {
        const cusId = this.tempTopList[0].customerId
        const isF = this.tempTopList.every((m) => m.customerId === cusId)
        if (isF && (this.bottomList.length === 0 || this.bottomList[0].customerId === cusId)) {
          this.tempTopList.forEach((ele) => {
            this.topChange(ele)
          })
        } else {
          this.$message.error('仅允许同一客户的产品移入发货区！')
        }
      }
    },
    onRowClickT(row) {
      this.$refs.topTableRef.toggleRowSelection(row)
    },
    handleSelectionChangeT(val) {
      this.tempTopList = val
    },
    // -------------发货区
    RowDbclickB(row) {
      const index = this.bottomList.findIndex((m) => m.moveInAndOut === row.moveInAndOut)
      this.bottomList.splice(index, 1)
    },
    onReleaseRepertoryB() {
      if (this.tempBotList.length > 0) {
        this.tempBotList.forEach((ele) => {
          this.RowDbclickB(ele)
        })
      } else {
        this.$message.error('请选中产品！')
      }
    },
    onRowClickB(row) {
      this.$refs.botTableRef.toggleRowSelection(row)
    },
    handleSelectionChangeB(val) {
      this.tempBotList = val
    },
    // 列表数据
    getList() {
      this.loadingTable = true
      if (this.activeName === '1') {
        this.params.ids = this.listID.toString()
      }
      queryDeliverContent(this.activeName, this.currentPage, this.pageSize, this.params).then(
        (res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.total = res.data.obj.total
            this.list = res.data.obj.records
            this.list.forEach((m, i) => {
              m.max = +m.count
              this.bottomList.forEach((ele) => {
                if (m.moveInAndOut === ele.moveInAndOut) {
                  m.count = m.max - ele.count
                }
              })
            })
          } else {
            this.$message.error(res.data.msg)
          }
        }
      )
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // tabs切换时触发的事件
    handleClick() {
      if (this.activeName !== '1') {
        this.bottomList = []
      }
      this.onReset()
    },
    // 页数
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    handleExport() {
      const searchParmas = {}
      this.valList.forEach(item => {
        searchParmas[item.column] = item.value
      })
      if (this.time.length) {
        searchParmas.signingTimeBegin = this.time[0]
        searchParmas.signingTimeEnd = this.time[1]
      }
      const params = {
        invoicePayUrl: '',
        deliveryList: searchParmas,
        deliveryLists: this.tempTopList
      }
      switch (this.activeName) {
        case '1':
          params.invoicePayUrl = '60ab705767e4306e13db3c6e'
          this.unshippedExport(params)
          break
        case '4':
          params.invoicePayUrl = '60adfb1867e4cd0db1df1cd0'
          this.shippedExport(params)
      }
    },
    // 未发货
    unshippedExport(params) {
      this.exportLoading = true
      unshippedExport(params)
        .then(res => {
          if (res.status === 200) downLoadFileBlob(this, res)
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    // 已发货
    shippedExport(params) {
      this.exportLoading = true
      shippedExport(params)
        .then(res => {
          if (res.status === 200) downLoadFileBlob(this, res)
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          this.exportLoading = false
        })
    }
  }
}
</script>
